<form [formGroup]="productForm" class="flex flex-col gap-6">
  <app-has-sub-products-toggle [value]="hasSubProducts()" (toggle)="onToggle($event)" />

  <app-product-basic-info
    [hasSubProducts]="hasSubProducts()"
    [mfgCompanies]="mfgCompanies()"
    [categories]="categories()"
    [subCategories]="subCategories()" />

  <app-product-images
    [images]="selectedImages()"
    [errors]="imageErrors()"
    (fileSelect)="handleFileSelect($event)"
    (setPrimary)="setPrimary($event)"
    (removeImg)="removeImg($event)" />

  @if (!hasSubProducts()) {
    <app-product-prices [zones]="zones()" />
  }

  <app-cancel-dialog
    [visible]="showCancelDialog()"
    (confirm)="confirmCancel()"
    (dismiss)="showCancelDialog.set(false)" />

  <div class="flex items-center justify-end gap-3 border-t border-gray-100 pt-5">
    <button
      type="button"
      (click)="showCancelDialog.set(true)"
      class="cursor-pointer rounded-lg border border-gray-200 bg-white px-8 py-2.5 text-sm font-semibold text-gray-600 transition hover:bg-gray-50"
      i18n="@@product.button.cancel">
      Cancel
    </button>
    <button
      type="button"
      (click)="submit()"
      [disabled]="loading()"
      class="bg-primary hover-bg-primary-hover cursor-pointer rounded-lg px-10 py-2.5 text-sm font-bold text-white shadow transition disabled:opacity-60">
      @if (loading()) {
        <span class="flex items-center gap-2">
          <svg class="me-2 h-4 w-4 animate-spin" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
          </svg>

          <span i18n="@@product.button.saving">Saving...</span>
        </span>
      } @else if (hasSubProducts()) {
        <span i18n="@@product.button.saveAndContinue">Save & Continue</span>
      } @else {
        <span i18n="@@product.button.save">Save</span>
      }
    </button>
  </div>
</form>
